require('./modal.scss');

const deps = [require('config').name, require('ng-dialog')];

/**
 * @param ngDialogProvider
 * @param {BenchConfig} config
 */
function configNgDialog(ngDialogProvider, config) {
  ngDialogProvider.setDefaults({
    className: 'bl-modal-default',
    showClose: false,
    plain: true, // use plain string as template
    appendTo: 'body',
    disableAnimation: config.noAnimations,
  });
}

module.exports = angular.module('bench.ui.modal', deps).config(configNgDialog);
